import Route from "@ember/routing/route";
import { service } from "@ember/service";

export default class SshKeysRoute extends Route {
  @service availableServices;

  buildRouteInfoMetadata() {
    return { jumpable: true };
  }

  beforeModel() {
    this.availableServices.requireAccessTo(this, "compute");
  }

  model() {
    let { project } = this.modelFor("organization");
    return { project };
  }
}
